export type Session = {
  id: string;
  dbId: string;
  databaseUUID: string;
  userId: string;
  projectId?: string;
  name: string;
  memory: string;
  status: string;
  createdAt: string;
  host: string;
  expiryDate: string;
  ttl: string | null;
};

export enum SESSION_STATUS {
  CREATING = 'Creating',
  READY = 'Ready',
  NOT_READY = 'NotReady',
  EXPIRED = 'Expired',
  FAILED = 'Failed',
}
